
import { AccessCodeDebugPanel } from "@/components/AccessCodeDebugPanel";

const Debug = () => {
  return (
    <div className="container mx-auto px-4 py-8 space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">System Debug Console</h1>
        <p className="text-muted-foreground">
          Debug and test system functionality
        </p>
      </div>
      
      <AccessCodeDebugPanel />
    </div>
  );
};

export default Debug;
